module.exports = __webpack_public_path__ + "static/media/popupDouble.8979d1d6.png";